export default function setFormContent (formObject, selectedObject, objectType, elementType, modalElementId) {
  let selectedElement = selectedObject
  Object.keys(formObject[elementType]).forEach(field => {
    if (elementType !== objectType) {
      const elementTypes = elementType + 's'
      selectedElement = selectedObject[elementTypes].find(element => { return element.id === modalElementId })
    }

    if (field in selectedElement) {
      if (field === 'responsible') {
        formObject[elementType].responsible.content = selectedElement[field].id
      }
      if (field === 'responsible') {
        formObject[elementType].responsible.content = selectedElement[field].id
      }
      if (field !== 'responsible' && field !== 'responsible') {
        if (formObject[elementType][field].rtEditor) {
          if (document.getElementById(formObject[elementType][field].ref)) {
            const RTEditor = document.getElementById(formObject[elementType][field].ref)
            const element = RTEditor.getElementsByClassName('ql-editor')
            element[0].innerHTML = selectedElement[field]
          } else {
            formObject[elementType][field].content = selectedElement[field]
          }
        } else {
          formObject[elementType][field].content = selectedElement[field]
        }
      }
      formObject[elementType][field].error = ''
    }
  })
}
